import {callApi} from '@/lib/api/callApi';

/**
 * Enum for TournamentStatus values.
 * @readonly
 * @enum {number}
 */
const TournamentStatus = {
  PENDING: 0,
  ACTIVE: 1,
  INACTIVE: 2,
  REJECTED: 3,
  DRAFT: 4,
};
/**
 * 取得比賽列表與搜尋比賽列表
 * @param {Object} params 傳入的參數物件
 * @param {Number} params.offset 從多少數量之後開始回傳
 * @param {Number} params.limit 回傳多少數量
 * @param {[Number]} [params.cityId] 地級行政區代碼
 * @param {[Number]} [params.districtId] 縣級行政區代碼
 * @param {[TournamentStatus]} [params.status] 比賽狀態
 * @param {[Number]} [params.hostBy] 建立的機構
 * @param {String} [params.name] 搜尋的關鍵字
 * @returns {Promise} promise
 */
async function getTournaments({
  offset,
  limit,
  cityId,
  districtId,
  status = [1],
  hostBy,
  name,
  isNeedGroup = true,
}) {
  const params = {
    offset,
    limit,
    cityId,
    districtId,
    status,
    hostBy,
    name,
    isNeedGroup,
  };
  const res = await callApi({
    category: 'tournament',
    apiName: '',
    method: 'get',
    params,
  });
  return res.data;
}

/**
 * 取得比賽
 * @param {Object} id 比賽id
 * @returns {Promise} promise
 */
async function getTournamentById(id) {
  const res = await callApi({
    category: 'tournament',
    apiName: id,
    method: 'get',
  });
  return res.data;
}

/**
 * 報名比賽
 * @param {String} path.tournamentId 比賽id
 * @param {String} path.groupId 組別id
 * @param {Object} data post的資料
 * @returns {Promise} promise
 */
async function registerTournament({tournamentId, groupId}, data) {
  const res = await callApi({
    category: 'tournament',
    apiName: `${tournamentId}/groups/${groupId}/registration`,
    method: 'post',
    data,
  });
  return res.data;
}

/**
 * 報名比賽
 * @param {String} tournamentId 比賽id
 * @returns {Promise} promise
 */
async function getTournamentAddresses(tournamentId) {
  const res = await callApi({
    category: 'tournament',
    apiName: `${tournamentId}/addresses`,
    method: 'get',
  });
  return res.data;
}

/**
 * 取得對陣表
 * @param {String} id 比賽id
 * @param {String} groupId 組別id
 * @returns {Promise} promise
 */
async function getTournamentGroupMatches({id, groupId}) {
  const res = await callApi({
    category: 'tournament',
    apiName: `${id}/groups/${groupId}/matches`,
    method: 'get',
  });
  return res.data;
}

/**
 * 取得成績表
 * @param {String} id 比賽id
 * @param {String} groupId 組別id
 * @returns {Promise} promise
 */
async function getTournamentGroupScores({id, groupId}) {
  const res = await callApi({
    category: 'tournament',
    apiName: `${id}/groups/${groupId}/scores`,
    method: 'get',
  });
  return res.data;
}

/**
 * 取得對陣及成績表
 * @param {Object} params 傳入的參數
 * @param {Number} params.offset 第幾筆開始的資料
 * @param {Number} params.limit 共幾筆
 * @param {String} params.playerName 選手姓名
 * @param {String} params.teacherOrAgency 選手機構或老師
 * @param {Number} params.tournamentId 比賽id
 * @param {Number} params.groupId 組別id
 * @param {Number} params.subgroupNo 小組id
 * @returns {Promise} promise
 */
async function getMatchScores(params) {
  const res = await callApi({
    category: 'tournament',
    apiName: 'matchScores',
    method: 'get',
    params,
  });
  return res.data;
}

export default {
  TournamentStatus,
  getTournaments,
  getTournamentById,
  getTournamentAddresses,
  registerTournament,
  getTournamentGroupMatches,
  getTournamentGroupScores,
  getMatchScores,
};
